import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import CheckInput, { InputType } from '../../../../../../../atoms/CheckInput';

import css from './PurchasePaymentCard.module.scss';

interface Props extends React.ComponentProps<'input'> {
  tailDigits: string;
  onChange?: (e: React.ChangeEvent) => void;
}

const PurchasePaymentCard = ({
  tailDigits,

  onChange,
  ...attr
}: Props) => {
  const classes = classNames(css.PurchasePaymentCard);
  const intl = useIntl();

  return (
    <div className={classes}>
      <CheckInput
        {...attr}
        type={InputType.Radio}
        name="payment-creditcard"
        onChange={onChange}
      >
        {intl.formatMessage({ id: 'purchases.purchasePaymentCard.history' })}
        <span className={css.PurchasePaymentCard__Card}>
          <span className={css.PurchasePaymentCard__Mask}>•••• •••• •••• </span>
          {tailDigits}
        </span>
      </CheckInput>
    </div>
  );
};

export default PurchasePaymentCard;
